import { register, find } from '../../../../Javascript/Utils.js'

const SearchBar = el => {
  const componentPrefix = 'oHeaderSearchBar-'
  const submit = find(`.${componentPrefix}Submit`, el)
  const searchInput = find(`.${componentPrefix}SearchTerm`, el)
  const headerSearchInteractedEvent = new window.CustomEvent('headerSearchInteracted', {})

  if (submit) {
    submit.addEventListener('click', (e) => {
      e.stopPropagation()
      if (!el.classList.contains(`${componentPrefix}-open`)) {
        e.preventDefault()
        searchInput.focus()
        el.classList.add(`${componentPrefix}-open`)
        document.addEventListener('click', closeSearch)
        searchInput.addEventListener('transitionend', () => {
          document.dispatchEvent(headerSearchInteractedEvent)
        })
      } else {
        if (!searchInput.value) {
          e.preventDefault()
          closeSearch()
        }
      }
    })
  }

  if (searchInput) {
    searchInput.addEventListener('click', (e) => {
      e.stopPropagation()
    })
  }

  const closeSearch = () => {
    if (el.classList.contains(`${componentPrefix}-open`)) {
      el.classList.remove(`${componentPrefix}-open`)
      document.removeEventListener('click', closeSearch)
      searchInput.addEventListener('transitionend', () => {
        document.dispatchEvent(headerSearchInteractedEvent)
      })
    }
  }
}

register('SearchBar', SearchBar)
